import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import styles from "./styles.module.css";

/**
 * Shared page header for the report screens, so every report opens with the
 * same icon / title / hint block and a single slot for its filters.
 */
const ReportHeader = ({
  icon,
  tone = "blue",
  iconClass,
  title,
  subtitle,
  hint,
  children,
}) => (
  <div className={styles.header}>
    <div className={styles.main}>
      {icon && (
        <span className={`${styles.icon} ${iconClass || `kpi-icon-${tone}`}`}>
          {icon}
        </span>
      )}
      <div className={styles.text}>
        <div className={styles.titleRow}>
          <h4 className={styles.title}>{title}</h4>
          {hint && (
            <Tooltip title={hint} trigger={["hover", "click"]}>
              <InfoCircleOutlined className={styles.hint} />
            </Tooltip>
          )}
        </div>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
    </div>
    {children && <div className={styles.actions}>{children}</div>}
  </div>
);

export default ReportHeader;
